import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Guest } from "./guests.model";

/**
 * @class GuestsListPhoneNumber
 *
 */
export class GuestsListPhoneNumber extends Model {

    static get validationModel() {

        return {
            name: {
                label: 'GUEST_NAME'
            },
            phone: {
                label: 'PHONE_NUMBER'
            }
        };
    }

    /**
     * @param {Object|Guest} value
     * @returns {Guest}
     */
    setGuest(value) {

        if (value) {

            return value instanceof Guest ? value : new Guest(value);
        }

        return value;
    }
}

AccessorsMutatorsDecorator('id', 'guests_list_id', 'guest_id', 'name', 'phone_code', 'phone', 'phone_number', 'guest')(GuestsListPhoneNumber);


// WEBPACK FOOTER //
// ./src/pms-api/models/guests-list-phone-number.model.js